module.exports = "https://coursera_assets.s3.amazonaws.com/images/4db8408a269c2d6804a5ac33536af429.png";